export default __webpack_public_path__ + "static/media/confirm.4469a461.jpg";